import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { BBLHero } from '../components/bbl/BBLHero';
import { BBLWhyWeLove } from '../components/bbl/BBLWhyWeLove';
import { BBLWhatIs } from '../components/bbl/BBLWhatIs';
import { BBLConcerns } from '../components/bbl/BBLConcerns';
import { BBLForeverYoung } from '../components/bbl/BBLForeverYoung';
import { BBLCombine } from '../components/bbl/BBLCombine';
import { BBLAddOns } from '../components/bbl/BBLAddOns';
import { BBLFAQ } from '../components/bbl/BBLFAQ';
import { BBLWhyChoose } from '../components/bbl/BBLWhyChoose';
export function BBLPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2422">
      <Navigation data-id="element-2423" />
      <main data-id="element-2424">
        <BBLHero data-id="element-2425" />
        <BBLWhyWeLove data-id="element-2426" />
        <BBLWhatIs data-id="element-2427" />
        <BBLConcerns data-id="element-2428" />
        <BBLForeverYoung data-id="element-2429" />
        <BBLCombine data-id="element-2430" />
        <BBLAddOns data-id="element-2431" />
        <BBLFAQ data-id="element-2432" />
        <BBLWhyChoose data-id="element-2433" />
      </main>
      <Footer data-id="element-2434" />
    </div>;
}